import { SorterTypes } from '@shared/filters/entities/sorter-options';

export type CheckboxFilter = Readonly<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Text: any;
  Label?: string;
  Count: number;
  TextTransformed?: string;
  MinPrice?: number;
  Stops?: number;
  AirportName?: string;
  AirlineName?: string;
}>;

export type CheckboxFilterVm = Readonly<{
  Image?: string;
}> & CheckboxFilter;

export type RangeResponseFilter = Readonly<{
  Text: string;
  From: string | number;
  To: string | number;
  SectorNumber?: number
}>;

export enum RangeType {
  PRICE = 'PRICE',
  TIME = 'TIME',
  NUMBER_TIME = 'NUMBER_TIME'
}

export type RangeFilterVm = Readonly<{
  RangeType: RangeType;
}> & RangeResponseFilter;

export type PriceRangeFilter = Readonly<{
  Text: string;
  Ocurrence: number;
  UpperBound?: number;
  LowerBound?: number
}>;

export type PriceFilter = Readonly<{
  min: number;
  max: number
}>;

export type RangePicketVm = Readonly<{
  [key: string]: string[] | number[]
}>;

export type PickedRange = Readonly<{
  [key: string]: PickedRangeValues;
}>;

export type PickedRangeValues = string[] | number[] | RangePicketVm;

export type AirFilterTabsResponse = Readonly<{
  OrderCriteria: SorterTypes;
  OrderCriteriaAux?: string;
  Duration: string,
  Amount: number,
  SectorNumber?: number,
  OrderDesc?: boolean
}>;

export type AirportsResponse = Readonly<{
  SectionNumber?: number,
  SectorNumber?: number,
  Airports: CheckboxFilter[]
}>;

export type AirportsResponseVm = Readonly<{
  SectionNumber: number,
  Airports: CheckboxFilter[]
}>;

export type AirFilterTabsFilter = Readonly<{
  order?: number
}> & AirFilterTabsResponse;

export type FilterSorter = Readonly<{
  Label: string,
}>&FilterSorterCriterias;

export type FilterSorterCriterias = Readonly<{
  OrderCriteria: SorterTypes,
  OrderCriteriaAux?: string,
  OrderDesc: boolean,
  SectorNumber?: number
}>;
